import { CreditCardTwoTone, MailFilled, MailOutlined, PhoneFilled, FundViewOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Form, Grid, Modal, Row, Tooltip, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Link, useNavigate } from 'react-router-dom';
import { CopyFilled } from '@ant-design/icons';
import { WalletType } from '../types/WalletType';
import { useEffect, useMemo, useState } from 'react';
import { TransactionStatus } from '../components/TransactionStatus';
import { WalletStatus } from '../types/WalletStatus';
import { getUserInfo } from '../../../helpers/localStorageHandler';
import axios from 'axios';
import { API_ENDPOINTS } from '../../../assets/api/endpoints';
import { OTPTransactionModal } from './OtpTransactionModal';
import { PreviewPhoto } from '../../../components/previewPhoto/PreviewPhoto';
import { useConfigurationContext } from '../../../store/configurationContext';
import CaptchaButton from '../../../components/Button/CaptchaButton';
import { CommentsModal } from '../../WithdrawRequest/modals/CommentsModal';
import TextArea from 'antd/es/input/TextArea';
import ActionButton from '../../../components/ActionButton.tsx/ActionButton';

type Account = {
	group: string;
	number: number;
	platform: string;
	balance: string;
};
type Request = {
	requestId: number;
	status: string;
	resolutionTime: string;
	assignedOn: string;
	assigneeName: string;
	assigneeId: number;
	actionBy: string;
};
type TransactionReportModalProps = {
	open?: boolean;
	payload?: {
		status: string;
		request: Request;
		date?: string;
		account?: string;
		withdrawCommission?: string;
		wallet?: string;
		amount?: string;
		transactionNumber: string;
		role: string;
		userName: string;
		phone: string;
		email: string;
		type: string;
		quantity: string;
		createdAt: string;
		orderNumber: string;
		currency: string;
		walletNumber: number;
		tradingAccount: Account;
		depositBonus: string;
		withdrawComission: string;
		id: number;
		fileId: string;
		fileLabel: string;
		comment?: string;
		createdByUserName?: string;
	};
	isRequestLoading: boolean;
	setOpen: (open: boolean) => void;
	title?: string;
	setShowUserListPopup?: (open: boolean) => void;
	handelAssign?: (userId: number) => void;
	onRequestAction?: (value: string, token?: string, isEnabled?: boolean, comments?: string, otp?: string) => void;
	showMailModal: (open: boolean) => void;
	showOtpModal: boolean;
	setShowOtpModal: (open: boolean) => void;
};

export const TransactionReportModal = (props: TransactionReportModalProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const userInfo = getUserInfo();
	const { configurationState } = useConfigurationContext();

	const [aggree, setAggree] = useState(false);
	const [photo, setPhoto] = useState('');
	const [showPreviewPhoto, setShowPreviewPhoto] = useState(false);
	const [recaptcha, setRecaptcha] = useState('');
	const [isEnabled, setIsEnabled] = useState(false);
	const [version, setRecapchaV] = useState('');
	const [comments, setComments] = useState('');

	const isSuperUser = userInfo?.role === 'SUPER_USER';
	const showUserLivePicture =
		((props.payload?.status === 'COMPLETED' ||
			props.payload?.status === 'REVERTED' ||
			props.payload?.status === 'CANCELLED') &&
			isSuperUser) ||
		props.payload?.status === 'PENDING_APPROVAL';

	const withdraw_required_live_picture =
		configurationState.find((item) => item.configKey === 'withdraw_required_live_picture')?.value || false;
	const request_action_otp_enabled = configurationState.find((item) => item.configKey === 'request_action_otp_enabled')
		?.value
		? configurationState.find((item) => item.configKey === 'request_action_otp_enabled')?.value === 'true'
		: true;

	const fields = useMemo(
		() =>
			[
				{ label: t('status'), value: <TransactionStatus status={props.payload?.status as WalletStatus} />, show: true },
				{
					label: t('transactionId'),
					value: (
						<>
							<div id='transactionId'> {props.payload?.transactionNumber}</div>{' '}
							<CopyFilled className='mx-1 cursor-pointer' onClick={() => copyMyText('transactionId')} />
						</>
					),
					show: true,
				},
				{ label: t('date'), value: dayjs(props.payload?.createdAt).format('DD/MM/YYYY hh:mm:ss'), show: true },
				{
					label: t('account'),
					value: (
						<>
							<div id='account'>
								{props.payload?.tradingAccount?.group}| {props.payload?.tradingAccount?.number} |{' '}
								{props.payload?.tradingAccount?.platform} | {props.payload?.tradingAccount?.balance}
							</div>
							<CopyFilled className='mx-1 cursor-pointer' onClick={() => copyMyText('account')} />
						</>
					),
					show: !props.title?.includes('P2P') && !props.title?.includes('ADMIN_WALLET'),
				},
				{
					label: t('withdrawCommission'),
					value: props.payload?.withdrawComission,
					show: !props.title?.includes('P2P') && props.payload?.withdrawComission,
				},
				{
					label: t('depositBouns'),
					value: props.payload?.depositBonus,
					show: !props.title?.includes('P2P') && props.payload?.depositBonus,
				},
				{
					label: t('orderNumber'),
					value: (
						<>
							{' '}
							<div
								onClick={() => navigate(`/order-life-cycle?id=${props.payload?.orderNumber}`)}
								style={{ color: '#409cff', textDecoration: 'underline', cursor: 'pointer', display: 'inline-block' }}
								id='orderNumber'
							>
								{' '}
								{props.payload?.orderNumber}
							</div>{' '}
							<CopyFilled className='mx-1 cursor-pointer' onClick={() => copyMyText('orderNumber')} />
						</>
					),
					show: props.title?.includes('P2P'),
				},
				{
					label: t('Currency/Wallet'),
					value: (
						<>
							<div>
								{props.payload?.currency} |
								<Link
									to={`/${props.payload?.role === 'MERCHANT' ? 'merchant' : 'client'}/?id=${props.payload
										?.id}&action=wallets`}
									className='hover:text-black text-black underline'
								>
									<span id='wallet'>{props.payload?.walletNumber}</span>
								</Link>
							</div>
							<CopyFilled className='mx-1 cursor-pointer' onClick={() => copyMyText('wallet')} />
						</>
					),
					show: true,
				},
				{ label: t('amount'), value: props.payload?.quantity, show: true },
				{ label: t('Comment'), value: props.payload?.comment, show: Boolean(props.payload?.comment) },
				{
					label: t('createdBy'),
					value: props.payload?.createdByUserName,
					show: Boolean(props.payload?.createdByUserName),
				},
			].filter((item) => item.show),
		[props.payload],
	);

	const nameInitials = String(props?.payload?.userName)
		?.split(' ')
		.map((name) => String(name?.[0])?.toUpperCase())
		.join('');

	const transactionTypeTitle = (type: WalletType) => {
		switch (type) {
			case WalletType.P2P_BUY:
				return t('p2pBuyOrder');
			case WalletType.P2P_SELL:
				return t('p2pSellOrder');
			case WalletType.TRADING_DEPOSIT:
				return t('depositToTradingAccount');
			case WalletType.TRADING_WITHDRAW:
				return t('withdrawFromTradingAccount');
			default:
				return t(type);
		}
	};

	const copyMyText = (value: string) => {
		const textToCopy = document.getElementById(value) as HTMLInputElement;
		if (textToCopy) {
			navigator.clipboard.writeText(textToCopy.innerHTML);
			notification['success']({ message: '', description: t<string>('copiedSuccessfully') });
		}
	};

	const vervifyOtp = (otp: string) => {
		onRequest(aggree, otp);
	};
	const downloadFile = () => {
		axios
			.get(
				API_ENDPOINTS.getTransactionImage
					.replace('%transactionNumber%', props?.payload?.transactionNumber ?? '')
					.replace('%fileName%', props?.payload?.fileId ?? ''),
				{
					responseType: 'arraybuffer',
				},
			)
			.then((response) => {
				const base64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
				setPhoto(base64);
			})
			.catch(console.error);
	};

	const onRequest = (isAggree: boolean, otp?: string) => {
		if (isAggree) {
			props.onRequestAction?.('ACCEPT', recaptcha, isEnabled, comments, otp);
		} else {
			props.onRequestAction?.('REJECT', recaptcha, isEnabled, comments, otp);
		}
	};

	useEffect(() => {
		if (
			props.open &&
			props.payload?.transactionNumber &&
			props?.payload?.fileId &&
			props.title === WalletType.TRADING_WITHDRAW
		) {
			downloadFile();
		} else {
			setPhoto('');
		}
	}, [props.open]);
	return (
		<>
			<Modal
				width={640}
				open={props?.open}
				footer={null}
				closable={true}
				onCancel={() => props.setOpen(false)}
				zIndex={1}
				destroyOnClose
			>
				<div className='flex flex-col gap-2'>
					<div className='mx-auto'>
						<div className='rounded-full w-16 h-16 bg-[#eee] flex items-center justify-center'>
							<CreditCardTwoTone className='text-2xl' />
						</div>
					</div>
					<div className='font-bold xss:text-sm md:text-lg text-center flex justify-center'>
						{transactionTypeTitle((props.title as WalletType) || 'P2P_BUY')}
					</div>
					<Row>
						{/** Left */}
						<Col
							span={props.payload?.type === 'TRADING_WITHDRAW' && props.payload?.request != null ? 12 : 24}
							style={{ padding: 'unset' }}
							className={
								props.payload?.type === 'TRADING_WITHDRAW' && props.payload?.request == null
									? 'flex justify-center'
									: ''
							}
						>
							<div
								className={
									props.payload?.type === 'TRADING_WITHDRAW' && props.payload?.request == null
										? 'flex flex-col items-center justify-center'
										: ''
								}
							>
								<div
									className='flex items-center gap-2 my-0.5 '
									style={
										props.payload?.type === 'TRADING_WITHDRAW' ? {} : { display: 'flex', justifyContent: 'center' }
									}
								>
									<Avatar className='bg-transparent border border-black text-black xss:text-[12px]'>
										{nameInitials}
									</Avatar>
									<Link
										to={`/${props.payload?.role === 'MERCHANT' ? 'merchant' : 'client'}/?id=${props.payload
											?.id}&action=wallets`}
										className='hover:text-black text-black'
									>
										<div className='font-bold  xss:text-sm md:text-lg '>{props?.payload?.userName}</div>
									</Link>
								</div>
								<div
									className='flex  xss:text-[7px] md:text-[10px] my-0.5 flex-row flex-wrap'
									style={{ justifyContent: props.payload?.type === 'TRADING_WITHDRAW' ? 'start' : 'center' }}
								>
									<div className='mr-1'>
										<PhoneFilled />
										<span className='mx-[2px]'>{props?.payload?.phone}</span>
									</div>
									<div>
										<MailFilled />
										<span className='mx-[2px]'>{props?.payload?.email}</span>
									</div>
								</div>
								<div
									className='my-1'
									style={
										props.payload?.type === 'TRADING_WITHDRAW' ? {} : { display: 'flex', justifyContent: 'center' }
									}
								>
									<Button
										icon={<MailOutlined />}
										className='shadow-none border-none bg-[#00AFFF] text-white hover:!text-white xss:!text-[8px] md:!text-[12px]'
										htmlType='button'
										size='small'
										onClick={() => props.showMailModal(true)}
									>
										{t('contactUser')}
									</Button>
								</div>
							</div>
						</Col>
						{/** Right */}
						{props.payload?.type === 'TRADING_WITHDRAW' && props.payload?.request != null && (
							<Col span={12} style={{ padding: 'unset', height: '100%' }}>
								<div className='border-dashed p-2 border-black/20 bg-yellow-100 justify-between text-black rounded-md flex flex-col h-full'>
									<div className='flex flex-col gap-2 xss:text-[8px] md:text-[12px] mb-2'>
										<div className='flex items-center justify-between'>
											<strong>{t('assignee')}:</strong>
											<span>{props?.payload.request?.assigneeName || '-'}</span>
										</div>
										<div className='flex items-center justify-between'>
											<strong>{t('assignedOn')}:</strong>
											<span>
												{dayjs(props?.payload?.request?.assignedOn ?? '').format('MMM D, YYYY h:mm A') || '-'}
											</span>
										</div>
										<div className='flex items-center justify-between'>
											<strong>{t('status')}:</strong>
											<span>{t(props?.payload?.request?.status) || '-'}</span>
										</div>
										{props?.payload?.request?.status !== 'PENDING_APPROVAL' && (
											<div className='flex items-center justify-between'>
												<strong>{t('actionBy')}:</strong>
												<span>{t(props?.payload?.request?.actionBy) || '-'}</span>
											</div>
										)}
									</div>
									{props?.payload?.request?.status == 'PENDING_APPROVAL' && (
										<div className='text-center'>
											<Button
												className='shadow-none  !px-4 border-none text-white hover:!text-white xss:!text-[10px] md:!text-[12px]'
												htmlType='button'
												disabled={userInfo?.role === 'ADMIN' && props.payload?.request?.assigneeId === userInfo?.id}
												style={
													userInfo?.role === 'ADMIN' && props.payload?.request?.assigneeId === userInfo?.id
														? { backgroundColor: 'lightgray' }
														: { backgroundColor: '#008dff' }
												}
												size='small'
												onClick={() =>
													userInfo?.role === 'ADMIN'
														? props.handelAssign?.(userInfo?.id ?? 1)
														: props.setShowUserListPopup?.(true)
												}
											>
												{userInfo?.role === 'ADMIN' ? t<string>('assigneToMe') : t<string>('Reassign')}
											</Button>
										</div>
									)}
								</div>
							</Col>
						)}
					</Row>
					<div className='my-2'>
						<div className='flex mb-2 text-black justify-between'>
							<p className='underline font-bold m-0'>{t('transactionReport')}</p>
							{props.payload?.fileLabel && showUserLivePicture && (
								<Tooltip title='User Live Picture'>
									<div className='text-[#1677ff]'>
										<FundViewOutlined className='text-[25px]' onClick={() => setShowPreviewPhoto(true)} />
									</div>
								</Tooltip>
							)}
						</div>
						<ul className='p-0 list-none flex flex-col gap-2 xss:text-[9px] md:text-[13px]'>
							{fields.map((field) => (
								<li key={field.label} className='flex items-center justify-between'>
									<span>{field.label}</span>
									<span className='font-bold flex'>{field?.value} </span>
								</li>
							))}
						</ul>
					</div>
					{props?.payload?.status == 'PENDING_APPROVAL' ? (
						<div>
							<div className='font-bold mb-2'>
								{t('note')}
								<span className='font-thin text-xs'>{t('optional')}</span>
							</div>
							<Form.Item name='message'>
								<TextArea
									onChange={(e) => setComments(e.target.value)}
									placeholder={`${t<string>('typeNoteHere')}...`}
									autoSize={{ minRows: 3, maxRows: 3 }}
									className='rounded-lg'
								/>
							</Form.Item>
						</div>
					) : null}
					{props?.payload?.status == 'PENDING_APPROVAL' ? (
						<div className='flex flex-col gap-4'>
							<div className='flex gap-4'>
								<ActionButton
									name='WALLET_TRADING_ACTION'
									onClick={() => {
										setAggree(true);
										props.setShowOtpModal(true);
									}}
									disabled={
										(getUserInfo()?.role === 'ADMIN' && props.payload?.request?.assigneeId !== getUserInfo()?.id) ||
										(version === 'v2' && isEnabled && !recaptcha) ||
										props.isRequestLoading
									}
									className='w-full text-xs border-none shadow-none text-white bg-green-500'
									htmlType='button'
									type='primary'
									id='transactionReport_accept'
								>
									{t('approve')}
								</ActionButton>
								<ActionButton
									name='WALLET_TRADING_ACTION'
									onClick={() => {
										setAggree(false);
										props.setShowOtpModal(true);
									}}
									disabled={
										(getUserInfo()?.role === 'ADMIN' && props.payload?.request?.assigneeId !== getUserInfo()?.id) ||
										(version === 'v2' && isEnabled && !recaptcha) ||
										props.isRequestLoading
									}
									className='w-full text-xs border-none shadow-none text-white bg-red-500 hover:!bg-red-900'
									htmlType='button'
									type='primary'
									id='transactionReport_reject'
								>
									{t('reject')}
								</ActionButton>
							</div>
							<div className='w-full flex justify-center'>
								<CaptchaButton
									setRecaptchaToken={setRecaptcha}
									setIsRecaptchaEnabled={setIsEnabled}
									action='WALLET_TRADING_ACTION'
									setRecapchaV={setRecapchaV}
								/>
							</div>
						</div>
					) : (
						<Button
							onClick={() => props.setOpen(false)}
							className='w-full border-none shadow-none text-white'
							style={{ background: 'linear-gradient(#00AFFF, #0077FF)' }}
							htmlType='button'
							size='large'
							type='primary'
						>
							{t('OK')}
						</Button>
					)}
				</div>
			</Modal>
			{props.showOtpModal && (
				<OTPTransactionModal
					showOtpModal={props.showOtpModal}
					setShowOtpModal={props.setShowOtpModal}
					amount={`${props.payload?.quantity}`}
					transactionNumber={`${props.payload?.transactionNumber}`}
					vervifyOtp={vervifyOtp}
					type={aggree}
					isLoading={false}
					showOtp={request_action_otp_enabled}
				/>
			)}
			{showPreviewPhoto && (
				<PreviewPhoto showModal={showPreviewPhoto} setShowModal={setShowPreviewPhoto} photo={photo} />
			)}
		</>
	);
};
